import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TApiPaginatedResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetAccrualPoliciesActivityRequestSchema,
  TGetAccrualPoliciesActivityResponseSchema,
} from "./getAccrualPoliciesActivity.schema";

export const getAccrualPoliciesActivity = (axios: IAxiosInstance) => {
  return async ({
    companyID,
    limit,
    start_at,
    sort_direction,
    sort_by,
  }: TGetAccrualPoliciesActivityRequestSchema) => {
    const { data } = await axios.noRetry.get<
      TApiPaginatedResponse<TGetAccrualPoliciesActivityResponseSchema>
    >(`/accrual-policies/activity`, {
      params: {
        companyID,
        limit,
        start_at,
        sort_direction,
        sort_by,
      },
    });

    if (data.success) {
      return data;
    }

    throw new Error("Something went wrong");
  };
};
